// @flow
import { useMutation, type MutationResult } from 'react-query';

import { assetUpload as assetUploadApi } from 'common/middleware/api';

type Variables = {
    clientId: string,
    file: File
};

export default function useUploadAsset(): MutationResult<Variables, void> {
    return useMutation<Variables, string>(async ({ clientId, file }) => {
        const formData = new window.FormData();
        formData.append('file', file);
        const params = {
            clientId
        };
        const { url } = await assetUploadApi.post(params, formData);
        return url;
    });
}
